export default "__VITE_ASSET__13a471f1__"